import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const ExcelStyledExport = ({ headers, data, filename }) => {

    const handleDownload = async () => {
        // 1. Création du classeur
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Commandes');

        // 2. Filtrage des données (identique à votre logique CSV)
        const newData = data.filter(row => {
            const allCellsAfterFirstAreZero = row.slice(1).every(cell => cell === 0);
            return !allCellsAfterFirstAreZero;
        }).map(row => row.map(cell => cell === 0 ? '' : cell));

        // 3. Ajout des colonnes et style du Header
        worksheet.columns = headers.map(h => ({
            header: h,
            key: h,
            width: h === '' ? 25 : 15 // Plus large pour la colonne des noms d'acheteurs
        }));

        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, color: { argb: 'FFFFFF' } };
        headerRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'E69437' } // Orange CourtJus
        };

        // 4. Ajout des données
        worksheet.addRows(newData);

        // 5. Application du style aux cellules (Bordures + Retour à la ligne)
        worksheet.eachRow((row, rowNumber) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.alignment = {
                    wrapText: true,
                    vertical: 'middle',
                    horizontal: rowNumber === 1 ? 'center' : 'left'
                };
            });
        });

        // 6. Génération et téléchargement
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, filename.replace('.csv', '.xlsx'));
    };

    return (
        <button onClick={handleDownload} className='btn-cdes-tab'>
            <img src="/img/xls.png" className={'btn-articles'} alt="Export Excel" />
        </button>
    );
};

export default ExcelStyledExport;